import angular = require("angular");
import {Config} from "../config";
import {EventType} from "../models/data";

export class ControlPanelController {

  static $inject = ["$routeParams", "session", "$location", "$uibModal", "$rootScope", "$document"];
  location;
  constructor($routeParams, session, $location, $modal, $rootScope, $document) {
    this.location = $location;

    window.location.href = Config.controlPanelEndpoint;
  }
}



/** WEBPACK FOOTER **
 ** ./src/scripts/controllers/controlPanel.ts
 **/